<div style="margin: 10px;">

	<halo-export-config [Network]="Network" [HaloExport]="HaloExport" [Agent]="Agent" [ScheduledDiscovery]="Discovery"
						[EnableExportOrigin]="true"></halo-export-config>

</div>
